export enum AuthStatus {
  authenticated,
  pending,
  unauthenticated,
  newPasswordRequired,
  forgetPassword,
}

export enum ErrorName {
  notAuthorizedException = 'NotAuthorizedException',
  invalidPasswordException = 'InvalidPasswordException',
  LimitExceededException = 'LimitExceededException',
}

export enum ErrorMessage {
  passwordAttemptsExceeded = 'Password attempts exceeded',
  incorrectUsernameOrPassword = 'Incorrect username or password.',
}
